import { useSyncExternalStore } from 'react';

const subscribeToNothing = () => () => undefined;
const getClientSnapshot = () => true;
const getServerSnapshot = () => false;

/**
 * `false` on the server and during hydration, `true` afterwards. Client-side
 * navigations return `true` straight away, so they never see the server branch.
 */
export const useHasHydrated = (): boolean =>
  useSyncExternalStore(subscribeToNothing, getClientSnapshot, getServerSnapshot);
